import { isEqual } from "lodash";

import { Slider } from "@mui/material";

import { useFilterContext } from "../FilterContext";

const FilterItemPremium = () => {
  const { filterData, setFilterData, filterOptions } = useFilterContext();

  return (
    <div className="pt-[40px] pb-[12px] px-[20px]">
      <Slider
        valueLabelDisplay="on"
        min={filterOptions.premiumRange[0]}
        max={filterOptions.premiumRange[1]}
        key={filterOptions.premiumRange[1]}
        valueLabelFormat={(v: number) => `${v}%`}
        value={
          filterData.premium.length > 0
            ? filterData.premium
            : [filterOptions.premiumRange[0], filterOptions.premiumRange[1]]
        }
        disableSwap
        onChange={(e, v) => {
          setFilterData({
            premium: isEqual(v as number[], [
              filterOptions.premiumRange[0],
              filterOptions.premiumRange[1],
            ])
              ? []
              : (v as number[]),
          });
        }}
      />
    </div>
  );
};

export default FilterItemPremium;
